import type { ThemeClasses } from "../types";
import { FilterPopover } from "../../../../shared";

interface TrackingLinkFiltersProps {
  accessType: string;
  status: string;
  searchQuery: string;
  isDarkMode: boolean;
  themeClasses: ThemeClasses;
  onAccessTypeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onStatusChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function TrackingLinkFilters({
  accessType,
  status,
  searchQuery,
  isDarkMode,
  themeClasses,
  onAccessTypeChange,
  onStatusChange,
  onSearchChange,
}: TrackingLinkFiltersProps) {
  const selectClasses = `w-full h-9 px-3 ${
    isDarkMode ? "bg-dark-card" : "bg-white"
  } border ${themeClasses.cardBorder} rounded-lg ${
    themeClasses.text
  } focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all text-sm`;

  return (
    <div className="flex items-center gap-2 flex-1 min-w-0">
      {/* Búsqueda */}
      <div className="relative flex-1 min-w-0 sm:flex-none sm:w-72">
        <i
          className={`ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 ${themeClasses.textSecondary}`}
        ></i>
        <input
          type="text"
          placeholder="Buscar por..."
          value={searchQuery}
          onChange={onSearchChange}
          className={`w-full h-9 pl-10 pr-4 py-2 ${
            isDarkMode ? "bg-dark-card" : "bg-white"
          } border ${themeClasses.cardBorder} rounded-lg ${
            themeClasses.text
          } focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all text-sm`}
        />
      </div>

      {/* Selects nativos: los handlers reciben el evento, así que sin "Limpiar". */}
      <FilterPopover
        isDarkMode={isDarkMode}
        activeCount={(accessType !== "all" ? 1 : 0) + (status !== "all" ? 1 : 0)}
      >
        {/* Tipo de Acceso */}
        <select
          value={accessType}
          onChange={onAccessTypeChange}
          aria-label="Tipo de Acceso"
          className={selectClasses}
        >
          <option value="all">Tipo de Acceso</option>
          <option value="public">Público</option>
          <option value="protected">Con código</option>
        </select>

        {/* Estatus */}
        <select
          value={status}
          onChange={onStatusChange}
          aria-label="Estatus"
          className={selectClasses}
        >
          <option value="all">Estatus</option>
          <option value="active">Activo</option>
          <option value="expired">Expirado</option>
          <option value="pending">Pendiente</option>
          <option value="inactive">Inactivo</option>
        </select>
      </FilterPopover>
    </div>
  );
}
